const skills = {
    1: [
        {
            title: "HTML",
            level: 5,
        },
        {
            title: "CSS",
            level: 5,
        },
        {
            title: "JavaScript",
            level: 4,
        },
        {
            title: "TypeScript",
            level: 3,
        },
        {
            title: "Tailwind CSS",
            level: 3,
        },
        {
            title: "React",
            level: 3,
        },
        {
            title: "Figma",
            level: 2,
        },
    ],
    2: [
        {
            title: "MySQL",
            level: 3,
        },
        {
            title: "Node.js",
            level: 4,
        },
        {
            title: "MongoDB",
            level: 2,
        },
        {
            title: "Git",
            level: 4,
        },
        {
            title: "PHP",
            level: 1,
        },
        {
            title: "SQL",
            level: 3,
        },
        {
            title: "Express",
            level: 3,
        },
    ]
};

export default skills;